module.exports = __webpack_public_path__ + "static/media/bg.74bc9603.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg.jpg
// module id = 612
// module chunks = 0